import { takeEvery, put, call } from 'redux-saga/effects';

import { URL_API } from '../../common/constants/common.js';
import { HttpConnection } from '../../common/helper/http-connection.js'
import { loginCheck, maintenanceCheck } from '../../common/helper/commonHelper.js';

function* getVocabularyList(action) {
    if(yield call(maintenanceCheck)){
        if(action.onFailure) {
            action.onFailure("403", "maintenance...");
        }
        return;
    }
    yield call(loginCheck);
    let http = new HttpConnection();
    let info = {
        url: URL_API + '/getVocabularyList',
        parameter: {
            id: action.subjectID,
            admin: action.admin,
        },
    }
    const data = yield call(http.post, info);
    if(data.statusCode === 200){
        if(action.onSuccess) {
            action.onSuccess(data.items);
        }
    } else {
        yield put({
            type: "ErrorInfo",
            source: "getVocabularyList",
            statusCode: data.statusCode,
            error: data.error,
        });
        if(action.onFailure) {
            action.onFailure(data.statusCode, data.error);
        }
    }
}

export const getVocabularyListSaga = takeEvery('GetVocabularyList_Saga', getVocabularyList);

function* setVocabulary(action) {
    if(yield call(maintenanceCheck)){
        if(action.onFailure) {
            action.onFailure("403", "maintenance...");
        }
        return;
    }
    yield call(loginCheck);
    let http = new HttpConnection();
    let info = {
        url: URL_API + '/setVocabulary',
        parameter: {
            id: action.vocabulary.id,
            subjectID: action.vocabulary.subjectID,
            textEn: action.vocabulary.textEn,
            textJp: action.vocabulary.textJp,
            order: action.vocabulary.order,
            check: action.vocabulary.check,
        },
    }
    const data = yield call(http.post, info);

    if(data.statusCode === 200){
        if(action.onSuccess) {
            action.onSuccess(data.id);
        }
    } else {
        yield put({
            type: "ErrorInfo",
            source: "setVocabulary",
            statusCode: data.statusCode,
            error: data.error,
        });
        if(action.onFailure) {
            action.onFailure(data.statusCode, data.error);
        }
    }
}

export const setVocabularySaga = takeEvery('SetVocabulary_Saga', setVocabulary);

function* deleteVocabulary(action) {
    if(yield call(maintenanceCheck)){
        if(action.onFailure) {
            action.onFailure("403", "maintenance...");
        }
        return;
    }
    yield call(loginCheck);
    let http = new HttpConnection();
    let info = {
        url: URL_API + '/deleteVocabulary',
        parameter: {
            id: action.id,
        },
    }
    const data = yield call(http.post, info);

    if(data.statusCode === 200){
        if(action.onSuccess) {
            action.onSuccess(action.id);
        }
    } else {
        yield put({
            type: "ErrorInfo",
            source: "deleteVocabulary",
            statusCode: data.statusCode,
            error: data.error,
        });
        if(action.onFailure) {
            action.onFailure(data.statusCode, data.error);
        }
    }
}

export const deleteVocabularySaga = takeEvery('DeleteVocabulary_Saga', deleteVocabulary);
